import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'


// 请求角色列表
export const getsmsTemplate = params => {
    return get("/admin/smsTemplate", params);
};

// 修改
export const editsmsTemplate = params => {
    return put(`/admin/smsTemplate/${params.id}`, params);
};

// 添加
export const addsmsTemplate = params => {
    return post("/admin/smsTemplate", params);
};

// 删除
export const deletesmsTemplate = params => {
    return del(`/admin/smsTemplate/${params}`);
};

// 开关
export const smsTemplateSwitch = params => {
    return get(`/admin/smsTemplate/${params}`);
};


// WEBPACK FOOTER //
// ./src/api/smsTemplate.js